export const getZipDifferenceCount = (zipSet1: Set<string>, zipSet2: Set<string>) => {
  const difference = new Set(Array.from(zipSet1).filter((zip) => !zipSet2.has(zip)));
  return difference.size;
};

export const parseZips = (zipText: string) => zipText.split(/\s+/).filter((word) => word !== '');
